import { makeStyles } from '@material-ui/core/styles'

type HtmlBlockPlaceholderProps = {
  source: string
  reason: 'limit' | 'too-large'
  onRender?: () => void
}

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(1.5, 0),
    width: '100%',
    borderRadius: 12,
    border: '1px solid var(--ds-border-default, #d7dae4)',
    background: 'var(--ds-bg-subtle, #f1f2f7)',
    padding: theme.spacing(2),
  },
  message: {
    margin: 0,
    fontSize: '0.875rem',
    color: 'var(--ds-fg-secondary, #535b6c)',
  },
  action: {
    marginTop: theme.spacing(1.5),
    borderRadius: 6,
    border: '1px solid var(--ds-border-default, #d7dae4)',
    background: 'transparent',
    padding: theme.spacing(0.75, 1.5),
    fontSize: '0.75rem',
    color: 'var(--ds-fg-secondary, #535b6c)',
    cursor: 'pointer',
    transition: 'background-color 160ms ease',
    '&:hover': {
      background: 'var(--ds-bg-subtle-hover, rgba(241, 242, 247, 0.7))',
    },
  },
}))

const HtmlBlockPlaceholder = ({ reason, onRender }: HtmlBlockPlaceholderProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <p className={classes.message}>
        {reason === 'limit'
          ? 'This preview is waiting to be loaded.'
          : 'This HTML block is too large to preview.'}
      </p>
      {reason === 'limit' ? (
        <button type="button" className={classes.action} onClick={onRender}>
          Render preview
        </button>
      ) : null}
    </div>
  )
}

export default HtmlBlockPlaceholder
